import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import jwtDecode from "jwt-decode";

const allowedIframeRoutes = ["/create-instant-quotation-iframe",];

function IframeRouteGuard() {
    let token = localStorage.getItem("Token");
    console.log("Token :", token);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        //check if admin if yes then logout 
        const isInIframe = window.self !== window.top;
        if (token && isInIframe) {
            let decode = jwtDecode(token);
            if (decode) {
                if (decode.userType == "admin") {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("_id");
                    localStorage.removeItem("firstName");
                    localStorage.removeItem("lastName");
                    localStorage.removeItem("isLoggedIn");
                    localStorage.removeItem("email");
                    localStorage.removeItem("pathAfterLogin");
                }
            }
        }
        //restict iframe to access different path

        if (isInIframe && !allowedIframeRoutes.includes(location.pathname)) {
            navigate("/create-instant-quotation-iframe");
        }
    }, [location]);

    return null;
}

export default IframeRouteGuard;
